import { ChangeDetectionStrategy, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SideNaveDataTypes } from '@klickdata/core/mobile/src/mobile.service';
import { MobileService } from '@klickdata/core/mobile';
import { OccasionDate } from '@klickdata/core/resource/src/resource.model';

@Component({
    selector: 'app-occasions-dates-viewer',
    templateUrl: './occasions-dates-viewer.component.html',
    styleUrls: ['./occasions-dates-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OccasionsDatesViewerComponent {
    @Input() dates: OccasionDate[];
    @Input() resourceLabel: string;
    @Input() canShowMore = false;
    @ViewChild('all_occasion_dates', { static: true }) allOccasionDates: TemplateRef<any>;
    @Input() timeZone: string;

    constructor(private mobile: MobileService) {}
    public showMoreDates() {
        this.mobile.updateSideNavSub({
            dataType: SideNaveDataTypes.GENERAL_NOTIFIER,
            data: {
                icon: 'calendar_month',
                title: $localize`Available Dates`,
                contentBody: $localize`Pls check all available dates.`,
                positiveBtn: $localize`Ok`,
                injectedTemplate: this.allOccasionDates,
                negativeBtn: $localize`Cancel`,
            },
        });
    }
}
